import { render, staticRenderFns } from "./PhotoDocumentContainer.vue?vue&type=template&id=0d61f529&scoped=true"
import script from "./PhotoDocumentContainer.vue?vue&type=script&lang=js"
export * from "./PhotoDocumentContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d61f529",
  null
  
)

export default component.exports